import { Navigate } from "react-router-dom";
import { AuthContext } from "../states/AuthContext";
import { Outlet } from "react-bootstrap-icons";
import { useContext } from "react";


export default function PrivateRoute({ children }) { 
  const { userLoggedIn, userProfileData } = useContext(AuthContext);
    
    return userLoggedIn ? children : <Navigate to="/login" /> ;

   
}